import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { CHANNEL_CLIENT_SERVICE, IClientActionService } from "../IClientActionService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  UiArguments,
  FnArg,
} from "shared/provider-webworker";
import { ClientActionPromiseService } from "./ClientActionPromiseService";
import { Injectable } from "@angular/core";
import { NotificationMethod } from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ClientActionReplicaService extends ClientActionPromiseService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    super();

    this.broker = this.factory.createMessageBroker(CHANNEL_CLIENT_SERVICE, true, true);
  }

  updateClientComments(
    clientCode: string,
    clientComment: string,
    privateComment: string,
  ): Promise<void> {
    let request = new UiArguments("updateClientComments");

    let arg1 = new FnArg(clientCode, PRIMITIVE);
    let arg2 = new FnArg(clientComment, PRIMITIVE);
    let arg3 = new FnArg(privateComment, PRIMITIVE);

    request.args = [arg1, arg2, arg3];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  saveClientContact(
    id: string,
    clientCd: string,
    contactName: string,
    desk: string,
    mobile: string,
    sms: string,
    email: string,
    isDefault: boolean,
    notifyEntry: NotificationMethod,
    notifyExpiry: NotificationMethod,
    notifyFill: NotificationMethod,
    notifyModify: NotificationMethod,
    notifyCancel: NotificationMethod,
  ): Promise<void> {
    let request = new UiArguments("saveClientContact");

    let arg1 = new FnArg(id, PRIMITIVE);
    let arg2 = new FnArg(clientCd, PRIMITIVE);
    let arg3 = new FnArg(contactName, PRIMITIVE);
    let arg4 = new FnArg(desk, PRIMITIVE);
    let arg5 = new FnArg(mobile, PRIMITIVE);
    let arg6 = new FnArg(sms, PRIMITIVE);
    let arg7 = new FnArg(email, PRIMITIVE);
    let arg8 = new FnArg(isDefault, PRIMITIVE);
    let arg9 = new FnArg(notifyEntry, PRIMITIVE);
    let arg10 = new FnArg(notifyExpiry, PRIMITIVE);
    let arg11 = new FnArg(notifyFill, PRIMITIVE);
    let arg12 = new FnArg(notifyModify, PRIMITIVE);
    let arg13 = new FnArg(notifyCancel, PRIMITIVE);

    request.args = [
      arg1,
      arg2,
      arg3,
      arg4,
      arg5,
      arg6,
      arg7,
      arg8,
      arg9,
      arg10,
      arg11,
      arg12,
      arg13,
    ];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  deleteClientContact(clientContactId: string): Promise<void> {
    let request = new UiArguments("deleteClientContact");

    let arg1 = new FnArg(clientContactId, PRIMITIVE);

    request.args = [arg1];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  saveClientTrader(
    clientCode: string,
    comment: string,
    userName: string,
    userCode: string,
    desk: string,
    mobile: string,
    email: string,
    isDefault: boolean,
  ): Promise<void> {
    let request = new UiArguments("saveClientTrader");

    let arg1 = new FnArg(clientCode, PRIMITIVE);
    let arg2 = new FnArg(comment, PRIMITIVE);
    let arg3 = new FnArg(userName, PRIMITIVE);
    let arg4 = new FnArg(userCode, PRIMITIVE);
    let arg5 = new FnArg(desk, PRIMITIVE);
    let arg6 = new FnArg(mobile, PRIMITIVE);
    let arg7 = new FnArg(email, PRIMITIVE);
    let arg8 = new FnArg(isDefault, PRIMITIVE);

    request.args = [arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  deleteClientTrader(clientCode: string, userName: string): Promise<void> {
    let request = new UiArguments("deleteClientTrader");

    let arg1 = new FnArg(clientCode, PRIMITIVE);
    let arg2 = new FnArg(userName, PRIMITIVE);

    request.args = [arg1, arg2];

    return this.broker.runOnService(request, PRIMITIVE);
  }
}
